import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";


import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    render() {
        return (
            <ParadigmaModal
                fileUploader={true}
                postUrl={api.proyectos.config.firmas.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"La Firma ha sido creado con éxito."}
                title={"Nueva Firma"}
                buttonIcon={"fa fa-plus fa-lg"}
                
                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}>
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className={'mt-2'}>
                    <Col className="col-2">
                        <Label>Cargo</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="cargo"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                
                <Row className={'mt-2'}>
                    <Col className="col-2">
                        <Label>Imagen</Label>
                    </Col>
                    <Col className="col-10">    
                        <Input type="file" name="imagen" accept="image/*"></Input>
                        <Input type="hidden" name="imagen2"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Firmas/Create.js